import { Box, Checkbox, CheckboxGroup, HStack, VStack } from "@chakra-ui/react";
import { useMemo } from "react";
import { normalizeDropdownOptions } from "../../utils/normalizeDropdownOptions";

export function CheckboxList({
  options: rawOptions,
  direction = "vertical",
  value,
  defaultValue,
  onChange,
  height = "120px",
  disabled,
}) {
  const options = useMemo(
    () => normalizeDropdownOptions(rawOptions, "CheckboxList"),
    [rawOptions]
  );

  const isVertical = direction === "vertical";
  const Wrapper = isVertical ? VStack : HStack;

  const wrapperProps = isVertical
    ? { spacing: 3, align: "stretch" }
    : { spacing: 4, wrap: "wrap" };

  return (
    <Box
      maxH={isVertical ? height : undefined}
      overflowY={isVertical ? "auto" : "visible"}
      borderWidth="1px"
      borderRadius="md"
      p={3}
    >
      <CheckboxGroup
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        isDisabled={disabled}
      >
        <Wrapper {...wrapperProps}>
          {options.map((opt) => (
            <Checkbox key={opt.value} value={opt.value}>
              {opt.label}
            </Checkbox>
          ))}
        </Wrapper>
      </CheckboxGroup>
    </Box>
  );
}
